// extracted by mini-css-extract-plugin
export default {"container":"list_container__I-s1W"};